import React from 'react'
import ProgressBar from '@ramonak/react-progress-bar'
import { IRangeLoader } from '../interfaces'

import style from '../styles/game.module.scss'
import '../styles/test.scss'

const RangeLoader = ({
  value = 20,
  label = 'Строим дома...'
}: IRangeLoader): React.ReactElement => {
  return (
    <div className={style['preloader__range--wrapper']}>
      <ProgressBar
        completed={value}
        className='preloader__range--wrapper'
        barContainerClassName='preloader__range--container'
        // completedClassName={"preloader__range--completed"}
        labelClassName='preloader__range--label'
        height='44px'
        // customLabel=""
        width='388px'
      />
      <div className={style['preloader__range--label']}>{label}</div>
    </div>
  )
}
export default RangeLoader
